// src/services/InventoryService.js
import { apiService } from './apiService';

export function getInventoryService({ search = '', page = 1, limit = 10, extra_filter = {} }) {
  return apiService({
    method: 'POST',
    url: '/inventory/select',
    data: { search, page, limit, extra_filter },
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function getByIdInventoryService(id) {
  return apiService({
    method: 'GET',
    url: '/inventory/' + id,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function addInventoryService(data) {
  return apiService({
    method: 'POST',
    url: '/inventory',
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateInventoryService(id, data) {
  return apiService({
    method: 'PUT',
    url: '/inventory/' + id,
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function deleteInventoryService(id) {
  return apiService({
    method: 'DELETE',
    url: '/inventory/' + id,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}